document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.testimonials-section').forEach(function(slideContainer, index) {
        const swiperContainer = slideContainer.querySelector('.swiper');
        const scrollbar = slideContainer.querySelector('.swiper-scrollbar');
        const nextButton = slideContainer.querySelector('.next');
        const prevButton = slideContainer.querySelector('.prev');

        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            grabCursor: true,
            scrollbar: {
                el: scrollbar,
                hide: false,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                }
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
        });
    });


    document.querySelectorAll('.product-slider-section').forEach(function(slideContainer, index) {
        const swiperContainer = slideContainer.querySelector('.swiper');
        const scrollbar = slideContainer.querySelector('.swiper-scrollbar');
        const nextButton = slideContainer.querySelector('.next');
        const prevButton = slideContainer.querySelector('.prev');

        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 30,
            grabCursor: true,
            scrollbar: {
                el: scrollbar,
                hide: false,
            },
            breakpoints: {
                500: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 4,
                },
                1024: {
                    slidesPerView: 6,
                }
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
        });
    });

    const footer = document.querySelector(".footer-utilities__text");
    if (footer) {
        footer.innerHTML = `
      <span>PIMABÉ 2026, MÜNCHEN ❤️<br>WEBSITE <a style="text-decoration: underline" href="https://www.youknowmewell.net" target="_blank" rel="noopener">YOU KNOW ME WELL STUDIO</a></span>
    `;
    }
});
